import type * as React from "react";

import { Button } from "./Button";
import { TriangleExclamationIcon } from "./Icons";
import { cn } from "../lib/cn";

export interface PanelErrorProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "children"
> {
  /** Tail of "I couldn't load ___.", lowercase with its article: "the timeline". */
  label: string;
  onRetry: () => void;
  ref?: React.Ref<HTMLDivElement>;
}

/** Fills its container; body ink because annotation is illegible on cork. */
export function PanelError({
  label,
  onRetry,
  className,
  ...rest
}: PanelErrorProps) {
  return (
    <div
      className={cn(
        "flex h-full min-w-0 flex-col items-center justify-center gap-3 p-10 text-center font-body",
        className,
      )}
      {...rest}
    >
      <p className="flex min-w-0 items-center gap-2 text-sm text-ink-body">
        <TriangleExclamationIcon className="text-ink-stopped" />I couldn&rsquo;t
        load {label}.
      </p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
